import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatMobile,
  formatName,
  formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  get,
  riskProfile,
} from "../../config";
import { useOrganization } from "../../lib/context/OrganisationContext";

const JointAccountDetailsPopup = ({
  jointAccountId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const { organizationData } = useOrganization();
  const [jointAccountDetail, setJointAccountDetail] = useState(null);
  const [jointAccountLoading, setJointAccountLoading] = useState(true);

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        // eslint-disable-next-line no-self-assign
        normalizedData[key] = normalizedData[key];
      }
    });
    return normalizedData;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.JOINT_ACCOUNT_DETAILS}/` + jointAccountId,
        );

        data?.data?.kyc &&
          data?.data?.kyc?.verifications?.length > 0 &&
          data?.data?.kyc?.verifications?.map((item) => {
            const normalizedData = normalizeVerificationData(
              item.data,
              item.verification_document_type,
            );
            item.date_verified = item.date_verified ? item.date_verified : null;
            item.verified_by = item?.verified_by ? item?.verified_by : "";
            item.type = item?.verification_document_type_id
              ? item?.verification_document_type_id
              : "";
            item.fields = item.verification_document_type?.fields?.map(
              (field) => ({
                key: field.key,
                label: field.label,
                value: normalizedData?.[field.key] ?? null,
                inputType: field.inputType || "text",
              }),
            );
            return item;
          });
        setJointAccountDetail(data.data);
        setJointAccountLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [jointAccountId, setJointAccountDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Joint Account Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {jointAccountLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>First Name:</strong>{" "}
                {jointAccountDetail?.first_name
                  ? jointAccountDetail?.first_name
                  : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {jointAccountDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {jointAccountDetail?.email}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {jointAccountDetail?.phone
                  ? formatPhone(jointAccountDetail?.phone)
                  : ""}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {jointAccountDetail?.mobile
                  ? formatMobile(jointAccountDetail?.mobile)
                  : "-"}
              </p>
              <p>
                <strong>Business Name:</strong>{" "}
                {jointAccountDetail?.business_name
                  ? jointAccountDetail?.business_name
                  : "-"}
              </p>

              <p>
                <strong>ABN:</strong>{" "}
                {jointAccountDetail?.abn
                  ? formatABN(jointAccountDetail?.abn)
                  : "-"}
              </p>
              <p>
                <strong>Licence Number:</strong>{" "}
                {jointAccountDetail?.license_number
                  ? jointAccountDetail?.license_number
                  : "-"}
              </p>
              <p>
                <strong>Code:</strong>{" "}
                {jointAccountDetail?.code ? jointAccountDetail?.code : "-"}
              </p>

              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  jointAccountDetail?.street,
                  jointAccountDetail?.suburb?.name,
                  jointAccountDetail?.state?.name,
                  jointAccountDetail?.postal_code,
                )}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                {formatedAddress(
                  jointAccountDetail?.shipping_street,
                  jointAccountDetail?.shipping_suburb?.name,
                  jointAccountDetail?.shipping_state?.name,
                  jointAccountDetail?.shipping_postal_code,
                )}
              </p>
              <p>
                <strong>Contact Type:</strong>{" "}
                {jointAccountDetail?.contactable_type
                  ? jointAccountDetail?.contactable_type === "vendor"
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )
                    : jointAccountDetail?.contactable_type === "contact"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "Customer",
                        )
                      : ""
                  : ""}
              </p>
              <p>
                <strong>
                  {jointAccountDetail?.contactable_type
                    ? jointAccountDetail?.contactable_type === "vendor"
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "vendors",
                          "Vendor",
                        )
                      : jointAccountDetail?.contactable_type === "contact"
                        ? getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )
                        : ""
                    : ""}
                  :
                </strong>{" "}
                {jointAccountDetail?.contactable
                  ? formatSubcontractorName(jointAccountDetail?.contactable)
                  : "-"}
              </p>
            </div>
          </div>
          {jointAccountDetail?.account_name && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Bank Account Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Bank Name:</strong>{" "}
                  {jointAccountDetail?.bank
                    ? jointAccountDetail?.bank?.abbreviation +
                      "-" +
                      jointAccountDetail?.bank?.name
                    : "-"}
                </p>
                <p>
                  <strong>Bank Account Name:</strong>{" "}
                  {jointAccountDetail?.account_name
                    ? jointAccountDetail?.account_name
                    : "-"}
                </p>
                <p>
                  <strong>BSB:</strong>{" "}
                  {jointAccountDetail?.bsb
                    ? formatBSBNumber(jointAccountDetail?.bsb)
                    : "-"}
                </p>
                <p>
                  <strong>Account Number:</strong>{" "}
                  {jointAccountDetail?.account_number
                    ? formatAccountNumber(jointAccountDetail?.account_number)
                    : "-"}
                </p>
                <p>
                  <strong>Opening Balance:</strong>{" "}
                  {jointAccountDetail?.opening_balance
                    ? "$" +
                      formatNumber(Number(jointAccountDetail?.opening_balance))
                    : "$0.00"}
                </p>
              </div>
            </div>
          )}

          {jointAccountDetail?.kyc && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Proof of ID for JointAccount Verification (KYC)
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                <p>
                  <strong>CDD Customer Type:</strong>{" "}
                  {jointAccountDetail?.kyc?.cdd_customer_type
                    ? cddCustomerTypeOptions?.find(
                        (item) =>
                          item.value ===
                          jointAccountDetail?.kyc?.cdd_customer_type,
                      )?.label
                    : "-"}
                </p>

                <p>
                  <strong>CDD:</strong>{" "}
                  {jointAccountDetail?.kyc?.cdd
                    ? cddOptions?.find(
                        (item) => item.value === jointAccountDetail?.kyc?.cdd,
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Risk Profile:</strong>{" "}
                  {jointAccountDetail?.kyc?.risk
                    ? riskProfile?.find(
                        (item) => item.value === jointAccountDetail?.kyc?.risk,
                      )?.label
                    : "-"}
                </p>

                <p className="col-span-2">
                  <strong>Note:</strong>{" "}
                  {jointAccountDetail?.kyc?.notes ? jointAccountDetail?.kyc?.notes : "-"}
                </p>
                <p className="col-span-2">
                  <strong>Nature & Purpose of Transaction:</strong>{" "}
                  {jointAccountDetail?.kyc?.ntf_note
                    ? jointAccountDetail?.kyc?.ntf_note
                    : "-"}
                </p>

                {jointAccountDetail?.kyc &&
                  jointAccountDetail?.kyc?.risk_profile_changes
                    ?.compliance_manager_id && (
                    <>
                      <p>
                        <strong>Escalated To:</strong>{" "}
                        {jointAccountDetail?.kyc?.risk_profile_changes
                          ?.compliance_manager_name
                          ? jointAccountDetail?.kyc?.risk_profile_changes
                              ?.compliance_manager_name
                          : "-"}
                      </p>

                      <p>
                        <strong>Reason:</strong>{" "}
                        {jointAccountDetail?.kyc?.risk_profile_changes?.reason
                          ? jointAccountDetail?.kyc?.risk_profile_changes
                              ?.reason
                          : "-"}
                      </p>
                    </>
                  )}
              </div>
              {jointAccountDetail?.kyc?.verifications?.map(
                (verifyItem, verifyIndex) => (
                  <>
                    {verifyIndex !== 0 && <hr className="my-2" />}
                    <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                      <p>
                        <strong>Verification Method:</strong>{" "}
                        {verifyItem?.method_title
                          ? verifyItem?.method_title
                          : "-"}
                      </p>
                      <p>
                        <strong>Document Id:</strong>{" "}
                        {verifyItem?.verification_document_type?.label
                          ? verifyItem?.verification_document_type?.label
                          : "-"}
                      </p>
                      {verifyItem?.method === 1 && (
                        <p>
                          <strong>Document Number:</strong>{" "}
                          {verifyItem?.document_number
                            ? verifyItem?.document_number
                            : "-"}
                        </p>
                      )}

                      {verifyItem?.method === 3 && (
                        <>
                          {verifyItem?.fields?.length > 0 &&
                            verifyItem?.fields?.map((field) => (
                              <p key={field.key}>
                                <strong>{field.label}:</strong> {field.value}
                              </p>
                            ))}
                        </>
                      )}
                      <p>
                        <strong>Verification Date:</strong>{" "}
                        {verifyItem?.date_verified
                          ? verifyItem?.date_verified
                          : "-"}
                      </p>
                      <p>
                        <strong>Verified By:</strong>{" "}
                        {verifyItem?.verified_by
                          ? formatName(
                              verifyItem?.verified_by?.first_name,
                              verifyItem?.verified_by?.last_name,
                            )
                          : "-"}
                      </p>
                    </div>
                  </>
                ),
              )}
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default JointAccountDetailsPopup;
